import { render } from "./DebugStorageSection.vue?vue&type=template&id=28af07ea"
import script from "./DebugStorageSection.vue?vue&type=script&lang=js"
export * from "./DebugStorageSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__